import { activatePageByPathInStore } from "page/tools/common"
import React, { useLayoutEffect, useState } from "react"
import { Router } from "react-router-dom"

interface ICustomRouterProps {
  history: any
  children: any
}

export const CustomRouter = React.memo(({ history, children }: ICustomRouterProps) => {
  const [state, setState] = useState({
    action: history.action,
    location: history.location
  })
  React.useEffect(() => {
    // a refresh here means that the location has changed
    activatePageByPathInStore(state.location.pathname)
  })
  useLayoutEffect(() => history.listen(setState), [history])
  return (
    <Router location={state.location} navigationType={state.action} navigator={history}>
      {children}
    </Router>
  )
})
